import axios from 'axios';
// post json to api
export const postJson = (url, params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            data: params,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            resolve(response.data);
        }
        ).catch(error => {
            reject(error);
        }
        );
    });
};

// fetch text from url
export const fetchText = (url) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            responseType: 'text'
        }).then(response => {
            resolve(response.data);
        }
        ).catch(error => {
            reject(error);
        }
        );
    });
};